const approachPoints = [
    {
      title: 'Tailored Recruitment Strategies',
      description:
        "We create personalized recruitment strategies aligned with your organization's unique values and goals.",
    },
    {
      title: 'Client-Centric Collaboration',
      description:
        'Our dedicated team forges meaningful partnerships, working closely to comprehend the intricacies of your business.',
    },
    {
      title: 'Seamless Candidate Matching',
      description:
        'We go beyond skills matching, ensuring candidates seamlessly integrate into your team and company culture.',
    },
    {
      title: 'Innovative HR Solutions',
      description:
        'Staying ahead requires innovation. We adopt cutting-edge tools and practices to keep your organization competitive.',
    },
    {
      title: 'Continuous Improvement',
      description:
        'We regularly evaluate and refine our processes based on client and candidate feedback, ensuring top-notch services.',
    },
    {
      title: 'Commitment to Diversity and Inclusion',
      description:
        'We actively promote diversity and inclusion, seeking candidates from diverse backgrounds to enrich your organization.',
    },
  ];
  export default approachPoints